// extracted by mini-css-extract-plugin
export default {"item":"Notification_item__V1a4d","body":"Notification_body__Qa19g","chip":"Notification_chip__+bfXB"};